import type { CalculationFilters } from "./CalculationInputList.types";

export const defaultPageSize = 10;
export const pageSizeOptions = [10, 25, 50, 75, 100];

export const emptyFilters: CalculationFilters = {
  name: "",
  lines: [],
  supplierIds: [],
  kamNames: [],
  planningYear: null,
  status: null,
};
